var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app","dir":_vm.isRtl}},[_c('router-view'),_c('auth-sidebar'),_c('notebook-sidebar'),_c('worker-sidebar'),_c('worker-sidebar-new'),_c('company-sidebar'),_c('jobs-sidebar'),_c('worker-contact-modal'),_c('regulated-professions-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }